import React, { useEffect } from "react";
import { Collapse, Nav } from "reactstrap";
import "./SidebarSections.css";

export const SidebarAccordion = ({
    sections,
    createLinks,
    sidenavOpen,
    openSectionId,
    setOpenSectionId,
    onExpandFromCollapsed,
    toggleSidenav
}) => {
    const toggleSection = (id) => {
        setOpenSectionId((prev) => (prev === id ? null : id));
    };

    const handleSectionClick = (id) => {
        if (!sidenavOpen && onExpandFromCollapsed) {
            // Sidebar is collapsed → expand + open this section
            onExpandFromCollapsed(id);
            toggleSidenav();
        } else {
            toggleSection(id);
        }
    };

    // Close all sections when sidebar collapses
    useEffect(() => {
        if (!sidenavOpen) {
            setOpenSectionId(null);
        }
    }, [sidenavOpen, setOpenSectionId]);

    return (
        <div className="sidebar-accordion">
            {sections.map((section) => {
                const isOpen = openSectionId === section.id;

                return (
                    <div
                        key={section.id}
                        className={`sidebar-section ${section.colorClass}`}
                        data-id={section.abbrev}
                        data-testid={`sidebar-section-${section.id}`}
                        onClick={(e) => {
                            if (sidenavOpen) {
                                return;
                            }
                            e.stopPropagation();
                            handleSectionClick(section.id);
                        }}
                    >
                        {sidenavOpen && !isOpen && (
                            <div
                                className="section-header d-flex align-items-center justify-content-between px-3 py-2"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleSectionClick(section.id);
                                }}
                            >
                                <span className="section-title pl-3">{section.title}</span>
                                <i className="fas fa-chevron-down" />
                            </div>
                        )}

                        <Collapse isOpen={isOpen && sidenavOpen}>
                            {sidenavOpen && section.logo && (
                                <div
                                    className="section-logo pl-4 pt-4 py-2 d-flex align-items-center justify-content-between"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSectionClick(section.id);
                                    }}
                                >
                                    <img
                                        src={section.logo.imgSrc}
                                        alt={section.title}
                                        className="section-logo-img"
                                    />
                                    <i className="fas fa-chevron-up text-white" />
                                </div>
                            )}
                            {sidenavOpen && <Nav navbar>{createLinks(section.routes)}</Nav>}
                        </Collapse>
                    </div>
                );
            })}
        </div>
    );
};
